// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Lfvo","header":"PatientBlock_header__FGLM9","label":"PatientBlock_label__1b7zO","option":"PatientBlock_option__yHfOS"};